
import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { createBillingPortalSession } from '@/services/stripe';
import { Button } from '@/components/ui/button';

interface ManagePaymentButtonProps {
  stripeCustomerId: string | undefined;
}

const ManagePaymentButton: React.FC<ManagePaymentButtonProps> = ({ stripeCustomerId }) => {
  const [isLoading, setIsLoading] = useState(false);
  
  const handleManagePayment = async () => {
    if (!stripeCustomerId) {
      toast("Erreur", {
        description: "Impossible de gérer le paiement pour ce compte"
      });
      return;
    }
    
    setIsLoading(true);
    
    try {
      const result = await createBillingPortalSession(stripeCustomerId);
      
      if ('error' in result) {
        toast("Erreur", {
          description: result.error
        });
        return;
      }
      
      // Redirect to Stripe Customer Portal
      window.location.href = result.url;
    } catch (error) {
      toast("Erreur", {
        description: "Une erreur est survenue lors de la création de la session de gestion"
      });
      console.error('Error creating portal session:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <Button 
      variant="outline" 
      size="sm"
      onClick={handleManagePayment}
      disabled={isLoading || !stripeCustomerId}
    >
      {isLoading ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Chargement...
        </>
      ) : (
        'Gérer le paiement'
      )}
    </Button>
  );
};

export default ManagePaymentButton;
